import type { RouteRecordRaw } from 'vue-router';

// Страницы импортируются файлами, а не барелем, чтобы каждая жила в своём
// чанке: чат позже потянет тяжёлый слой диалога, витрине он не нужен.
const VisaCountriesPage = () => import('./ui/pages/VisaCountriesPage.vue');
const VisaCountryPage = () => import('./ui/pages/VisaCountryPage.vue');
const VisaChatPage = () => import('./ui/pages/VisaChatPage.vue');

/**
 * Раздел отдаёт роутеру готовый набор записей: приложение подключает визу одним
 * спредом и про её страницы не знает. Статический сегмент `/visa` обязан стоять
 * до catch-all главной, иначе витрина стран туда не доедет.
 */
export const visaRoutes: RouteRecordRaw[] = [
  {
    path: '/visa',
    name: 'VisaCountriesPage',
    component: VisaCountriesPage,
  },
  {
    path: '/visa/:countryCode',
    name: 'VisaCountryPage',
    component: VisaCountryPage,
    props: true,
  },
  {
    path: '/visa/:countryCode/chat',
    name: 'VisaChatPage',
    component: VisaChatPage,
    props: true,
  },
];
